var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 307.71 238.06",
    style: {
      enableBackground: "new 0 0 307.71 238.06"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.24;}\n\t.st1{opacity:0.7;}\n\t.st2{fill:#E6E7E8;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{opacity:0.373;fill:#D1D3D4;enable-background:new    ;}\n\t.st5{fill:none;stroke:#A7A9AC;stroke-width:7.1736;stroke-linecap:round;}\n\t.st6{fill:#A7A9AC;}\n\t.st7{fill:none;stroke:#A7A9AC;stroke-width:10.4973;stroke-linecap:round;}\n\t.st8{opacity:0.2;}\n\t.st9{opacity:0.15;fill:#73C9EB;}\n\t.st10{fill:#20C5A0;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M204.64,203.84c-46.57,19.73-95.36,31.76-132.6,28.38c-37.4-3.01-63.25-21.43-67.71-54.09 c-4.97-32.42,12.72-70.73,36.39-101.99c24.02-31.54,54.02-56.01,81.9-67.23c28.62-11.29,52.54-7.95,79.43,3.16 c26.19,11.26,55.34,30.29,78.35,53.85c22.73,23.83,30.79,47.64,17.46,71.16C285.19,160.5,251.14,183.64,204.64,203.84z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_28_00000125598274315577052230000015643499942588473258_",
    transform: "translate(0.154)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 143.38,
    cy: 110.51,
    rx: 66.29,
    ry: 66.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_31_00000038380665879786767510000007760453910635281054_",
    className: "st9",
    cx: 145.04,
    cy: 111.86,
    rx: 60.28,
    ry: 60.09
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_28_00000054970498736224281700000006955577494101828516_",
    transform: "translate(0.154)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M142.46,180.03c-38.71,0-70.21-31.49-70.21-70.21s31.49-70.21,70.21-70.21s70.21,31.49,70.21,70.21 S181.17,180.03,142.46,180.03z M142.46,45.61c-35.41,0-64.21,28.81-64.21,64.21s28.8,64.21,64.21,64.21 s64.21-28.81,64.21-64.21S177.86,45.61,142.46,45.61z"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29_00000109730034527322118290000011561525560645120389_",
    className: "st10",
    cx: 174.13,
    cy: 104.04,
    r: 6.85
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30_00000058553512099691114860000008504561191921360771_",
    className: "st10",
    cx: 112.48,
    cy: 104.04,
    r: 6.85
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_131_00000067925431347359565850000010939616976223500948_",
    transform: "translate(28.464 50.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line_19_00000137836304028178128010000005646509952902543530_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M158.07,30.64c-0.55,0-1.11-0.15-1.61-0.47l-10.7-6.85c-1.39-0.89-1.8-2.75-0.91-4.14 c0.89-1.39,2.75-1.8,4.14-0.91l10.7,6.85c1.39,0.89,1.8,2.75,0.91,4.14C160.03,30.15,159.06,30.64,158.07,30.64z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_20_00000176012924020937920470000016373393720007252123_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M71.18,45.2c-0.99,0-1.96-0.49-2.53-1.38c-0.89-1.39-0.48-3.25,0.91-4.14l10.7-6.85 c1.39-0.89,3.25-0.49,4.14,0.91c0.89,1.39,0.48,3.25-0.91,4.14l-10.7,6.85C72.29,45.04,71.73,45.2,71.18,45.2z"
  })))), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 220.51,
    cy: 46.87,
    r: 4.85
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M232.73,83.28c-4.05,0-7.35-3.3-7.35-7.35s3.3-7.35,7.35-7.35c4.05,0,7.35,3.3,7.35,7.35 S236.79,83.28,232.73,83.28z M232.73,73.58c-1.3,0-2.35,1.05-2.35,2.35s1.05,2.35,2.35,2.35c1.3,0,2.35-1.05,2.35-2.35 S234.03,73.58,232.73,73.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M152,149.84c-1.62,0-3.3-0.26-4.97-0.78c-1.32-0.41-2.05-1.82-1.63-3.13c0.41-1.32,1.82-2.05,3.13-1.63 c3.24,1.02,6.42,0.61,8.74-1.11c1.48-1.1,2.42-2.63,2.41-3.9c-0.02-1.38,1.09-2.51,2.47-2.53c1.41,0.01,2.51,1.09,2.53,2.47 c0.04,2.91-1.62,5.89-4.42,7.97C157.9,148.94,155.03,149.84,152,149.84z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M197.71,173.06c-0.61,0-1.22-0.23-1.68-0.7l-8.28-8.28c-0.93-0.93-0.93-2.44,0-3.37 c0.93-0.93,2.44-0.93,3.37,0l8.28,8.28c0.93,0.93,0.93,2.44,0,3.37C198.92,172.83,198.32,173.06,197.71,173.06z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M90.4,37.61c-0.64,0-1.28-0.24-1.77-0.73L77.8,26.05c-0.98-0.98-0.98-2.56,0-3.54 c0.98-0.98,2.56-0.98,3.54,0l10.83,10.83c0.98,0.98,0.98,2.56,0,3.54C91.68,37.37,91.04,37.61,90.4,37.61z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M79.57,37.61c-0.64,0-1.28-0.24-1.77-0.73c-0.98-0.98-0.98-2.56,0-3.54l10.83-10.83 c0.98-0.98,2.56-0.98,3.54,0c0.98,0.98,0.98,2.56,0,3.54L81.34,36.88C80.85,37.37,80.21,37.61,79.57,37.61z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M239.95,196.13l-27.3-27.3c-2.24-2.24-5.23-3.48-8.4-3.48s-6.16,1.24-8.4,3.48c-4.63,4.63-4.63,12.17,0,16.8 l27.3,27.3c2.24,2.24,5.23,3.48,8.4,3.48c3.17,0,6.16-1.24,8.4-3.48c0,0,0,0,0,0c2.24-2.24,3.48-5.23,3.48-8.4 S242.2,198.37,239.95,196.13z M235.69,208.6C235.69,208.6,235.69,208.6,235.69,208.6c-1.35,1.35-3.14,2.09-5.05,2.09 c-1.91,0-3.7-0.74-5.05-2.09l-8.24-8.24c-0.3-0.22-0.59-0.45-0.86-0.72l-16.4-16.4c-2.78-2.78-2.78-7.31,0-10.09 c1.35-1.35,3.14-2.09,5.05-2.09c1.91,0,3.7,0.74,5.05,2.09l8.24,8.24c0.3,0.22,0.59,0.46,0.86,0.72l16.4,16.4 c1.35,1.35,2.09,3.14,2.09,5.05C237.78,205.46,237.04,207.26,235.69,208.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResult);
export default __webpack_public_path__ + "static/media/noResult.70b96d9864702e238fb05a4fdbddb4fd.svg";
export { ForwardRef as ReactComponent };